// Keep administration under /config and the public storefront at /.
// Existing links with hashes continue working after the domain change.
export function resolveRoute({ pathname = "/", search = "", hash = "" }) {
  const isConfig = pathname === "/config" || pathname === "/config/";
  const callback =
    /(?:^#|&)(?:access_token|refresh_token|error_description)=/.test(hash);
  if (callback) {
    return {
      route: isConfig ? "#admin/dashboard" : "#store",
      canonicalUrl: null,
    };
  }
  const privateRoute =
    /^#(?:admin(?:\/|$)|login(?:$|\?)|reset-password(?:$|\?))/.test(hash);
  const publicRoute = /^#(?:store(?:$|\?)|order\/|review\/)/.test(hash);
  const route =
    privateRoute || publicRoute
      ? hash
      : isConfig
        ? "#admin/dashboard"
        : "#store";
  const admin = /^#(?:admin|login|reset-password)/.test(route);
  const fragment = route === "#store" || (!hash && isConfig) ? "" : hash;
  return {
    route,
    canonicalUrl: `${admin ? "/config" : "/"}${search}${fragment}`,
  };
}
